import { render, staticRenderFns } from "./wtCollapseItem.component.vue?vue&type=template&id=6cca5245&"
import script from "./wtCollapseItem.component.vue?vue&type=script&lang=js&"
export * from "./wtCollapseItem.component.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports